import type { TowerDesign } from "@/game/towerSpec";
import type { Material } from "@/physics/model";
const A572_65: Material = { name: "A572 Gr65", E: 200e9, Fy: 448e6, rho: 7850 };
/** EXACT: base OD 36.05in -> top 16in (tnxTower TP sections), A572-65, TIA-222-H 125 mph Exp C, 1.00in ice. Foundation pier estimated. */
export const design: TowerDesign = {
  id: "monopole-verizon-120ft",
  name: "Monopole (Verizon 120 ft)",
  description: "Real 120 ft monopole, Verizon CT (A572-65, 125 mph, Exp C).",
  author: "reference: 02_engineering_drawings",
  spec: {
    type: "monopole",
    height: 36.58,
    stack: { faces: 12, panels: 12, baseRadius: 0.458, topRadius: 0.203,
      legSection: "legXXL", braceSection: "braceHeavy", legMaterial: A572_65, braceMaterial: A572_65, bracing: "X" },
    shell: { baseDiameter: 0.916, topDiameter: 0.406 },
    foundation: { soil: "dense-sand",
      base: { type: "pier", width: 2.4, diameter: 2.4, depth: 6.5, concrete: "c30" },
      connection: { kind: "anchorBolts", nBolts: 12, bolt: "b1_75", grade: "f1554_105", boltCircleDia: 1.2, embedment: 0.45, edgeDistance: 0.3, platePlanArea: 1.8, plateThickness: 0.05, plateGrade: "a36rod", fc: 30e6 } },
  },
};
